import { Currenttab_learn, Currenttab_joinme, Currenttab_home, Currenttab_About, Currenttab_Games } from '../Actions/Actions'

const initialstate = {
    currenttab:"Home"
}

const currenttabreducer = (state = initialstate, actions) => {
    switch (actions.type) {
        case Currenttab_home: return {
            currenttab:"Home"
        }
          

        case Currenttab_learn: return {
            currenttab:"Learn"
        }
          
        case Currenttab_joinme: return {
            currenttab:"Joinme"
        }
            
        case Currenttab_Games: return {
            currenttab:"Games"
        }
          
        case Currenttab_About: return {
            currenttab:"About"
        }
           
        default:return{
            state
        }
      
           
    }
}

export default currenttabreducer